module.exports = __webpack_public_path__ + "media/images/facebook_white_inactive_logo-980c7621211c781b157f426cd8be024e.svg";